import React from "react";

const IMAGES = [
  { src: "/img/gallery/1.webp",  alt: "Corona Gas rooftop AC installation", span: "row-span-2" },
  { src: "/img/gallery/91.webp", alt: "Furnace and mechanical room install", span: "" },
  { src: "/img/gallery/4.webp",  alt: "Gas piping and connections", span: "" },
  { src: "/img/gallery/5.webp",  alt: "Corona Gas service vehicle on-site", span: "" },
  { src: "/img/gallery/9.webp",  alt: "Ductwork and HVAC mechanical", span: "row-span-2" },
  { src: "/img/gallery/7.webp",  alt: "Commercial rooftop mechanical unit", span: "" },
  { src: "/img/gallery/8.webp",  alt: "Heat pump exterior installation", span: "" },
  { src: "/img/gallery/92.webp", alt: "Boiler and hot water system", span: "" },
];

const Gallery = () => {
  return (
    <section id="gallery" className="py-20 lg:py-28 bg-[#FAFAFA]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="eyebrow justify-center inline-flex mb-4">Our Work</div>
          <h2 className="font-[Manrope] font-extrabold text-[#0F0F0F] text-3xl sm:text-4xl lg:text-5xl leading-tight mb-4">
            Recent Projects Across BC
          </h2>
          <p className="text-[#475569] text-lg">
            From residential furnaces to commercial rooftop systems, see the quality of our work.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 grid-flow-row-dense gap-4 auto-rows-[200px]">
          {IMAGES.map((img, i) => (
            <div
              key={i}
              className={`relative overflow-hidden rounded-2xl group ${img.span}`}
              data-testid={`gallery-img-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-3 left-3 text-white text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                {img.alt}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
